<div class="card teamprogress_container">
  <div class="card-head header">
    <span class="card-head-text">My Team Progress</span>
    <div>
      <select class="filters pr-2" (change)="onTeamQuarterChange()" [(ngModel)]="teamQuarterNo">
        <option *ngFor="let data of quarterData" [value]="data.id">{{data.name}}</option>
      </select>
      <select class="filters pr-2" (change)="onTeamYearChange()" [(ngModel)]="teamYear" style="margin-left: 5px;">
        <option *ngFor="let data of yearData">{{data}}</option>
      </select>
      <button *ngIf="pieChart" class="filters chart-button" (click)="showTeamLineChart()"><mat-icon
          class="chart-icon">area_chart</mat-icon></button>
      <button *ngIf="!pieChart" class="filters chart-button" (click)="showTeamPieChart()"><mat-icon
          class="chart-icon">pie_chart</mat-icon></button>
    </div>
  </div>
  <hr>
  <div class="card-content p-2 pt-3">
    <div class="no-data" *ngIf="pieChart && pieDataNotFound">
      <span>No Data Found</span>
    </div>
    <p-chart *ngIf="pieChart && !pieDataNotFound" #chart3 type="pie" [data]="pieChartData" [options]="pieChartOptions"
      [height]="280"></p-chart>
    <p-chart *ngIf="!pieChart" #chart4 type="line" [data]="lineChartData2" [options]="chartOptions2"></p-chart>
    <div class="pictorial-content" *ngIf="!pieChart || (pieChart && !pieDataNotFound)">
      Pictorial representation of team learning progress
    </div>
  </div>
</div>
